import { render } from "./AddObjectStorage.vue?vue&type=template&id=9831379a&scoped=true"
import script from "./AddObjectStorage.vue?vue&type=script&lang=js"
export * from "./AddObjectStorage.vue?vue&type=script&lang=js"

import "./AddObjectStorage.vue?vue&type=style&index=0&id=9831379a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9831379a"]])

export default __exports__